import CustomModalWrapper from 'components/CustomModalWrapper/CustomModalWrapper';
import DetailTable from 'components/DetailTable';
import { ConfigItem } from 'components/DetailTable/types';
import ModalDialog from 'components/ModalDialog';
import moment from 'moment';
import React from 'react';
import { Col, Row } from 'reactstrap';

import { STATUS_BADGE_CLASS } from './BPAScanDataGrid.config';
import { BPAScan } from './types';

interface Props {
  scan: BPAScan;
  onClose: () => void;
}

const DATE_FORMAT = 'MMM DD, YYYY h:mm A';
const EMPTY = '—';

const formatDate = (date: string | null): string =>
  date ? moment(date).format(DATE_FORMAT) : EMPTY;

const SCAN_DETAIL_CONFIG: ConfigItem[] = [
  { name: 'Job ID', key: 't12_job_id', type: 'string' },
  { name: 'Account ID', key: 'account_id', type: 'string' },
  { name: 'Integration Name', key: 'integration_label', type: 'string' },
  { name: 'Region', key: 'region', type: 'string' },
  { name: 'Benchmark', key: 'benchmark_description', type: 'string' },
  { name: 'Status', key: 'status_badge', type: 'html' },
  { name: 'Job Type', key: 'job_type', type: 'string' },
  { name: 'Scan Type', key: 'trigger_type_label', type: 'string' },
  { name: 'Created At', key: 't12_created_at_label', type: 'string' },
  { name: 'Updated At', key: 't12_updated_at_label', type: 'string' },
  { name: 'Started At', key: 'started_at_label', type: 'string' },
  { name: 'Finished At', key: 'finished_at_label', type: 'string' },
  { name: 'Duration', key: 'scan_duration', type: 'string' },
];

const BPAScanDetailModal: React.FC<Props> = ({ scan, onClose }) => {
  const processedScan = {
    ...scan,
    benchmark_description: scan.benchmark_description ?? EMPTY,
    job_type: scan.job_type
      ? scan.job_type
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (c) => c.toUpperCase())
      : EMPTY,
    status_badge: `<span class="badge ${STATUS_BADGE_CLASS[scan.status]}">${scan.status.replace(/_/g, ' ')}</span>`,
    trigger_type_label: scan.trigger_type ?? EMPTY,
    started_at_label: formatDate(scan.started_at),
    finished_at_label: formatDate(scan.finished_at),
    scan_duration: scan.scan_duration || EMPTY,
    t12_created_at_label: formatDate(scan.t12_created_at),
    t12_updated_at_label: formatDate(scan.t12_updated_at),
  };

  return (
    <ModalDialog
      title="Scan Details"
      childComponent={
        <CustomModalWrapper id="bpa-scan-detail-scroll">
          <Row>
            <Col>
              <DetailTable data={processedScan} config={SCAN_DETAIL_CONFIG} />
            </Col>
          </Row>
        </CustomModalWrapper>
      }
      onClose={onClose}
      size="lg"
    />
  );
};

export default BPAScanDetailModal;
